import React, { useCallback, useEffect, useRef, useState } from 'react';
import ArticleList from 'components/blog/ArticleList';
import BlogLayout from 'components/blog/BlogLayout';
import AuthorProfile from 'app/components/blog/AuthorProfile';
import useGetArticles from 'entity/blog/hooks/useGetArticles';
import DropdownSelect from 'seedly-component-library/dropdown-select';
import {
  ArticleAuthorApiResponse,
  GetArticlesByCategoryParams,
} from 'entity/blog/blogTypes';
import blogApi from 'entity/blog/blogApi';

interface OwnProps {
  authorArticles: {
    articleResponse: ArticleAuthorApiResponse;
    articleParams: GetArticlesByCategoryParams;
  };
}

const AuthorContent = (props: OwnProps) => {
  const { authorArticles } = props;

  const {
    articles,
    isLoading,
    handleLoadArticles,
    handleLoadArticlesByPage,
    currentPage,
  } = useGetArticles({
    ...authorArticles,
    articleApi: blogApi.getArticlesByAuthor,
  });
  const {
    name,
    imageUrl,
    description,
    slug,
  } = authorArticles.articleResponse.data.author;

  const [orderBy, setOrderBy] = useState(authorArticles.articleParams.orderBy);

  // Refs
  const scrollToComponent = useRef(null);
  const selectContainer = useRef(null);
  const scrollToSelectContainer = () => {
    scrollToComponent.current(selectContainer.current, {
      offset: -140,
      align: 'top',
      duration: 100,
    });
  };

  const onPageChange = useCallback(
    ({ selected: page }) => {
      scrollToSelectContainer();
      handleLoadArticlesByPage({ page: page + 1, orderBy });
    },
    [handleLoadArticlesByPage, orderBy],
  );

  const onChangeOrder = (orderByParam: string) => {
    handleLoadArticles({
      page: 1,
      orderBy: orderByParam,
      perPage: 10,
      slug,
    });
    setOrderBy(orderByParam);
  };

  const SELECT_ITEMS = [
    {
      title: 'Most Recent',
      value: 'publishDate',
      onClick: () => onChangeOrder('publishDate'),
    },
    {
      title: 'Most Popular',
      value: 'views',
      onClick: () => onChangeOrder('views'),
    },
  ];

  // Effects
  useEffect(() => {
    scrollToComponent.current = require('react-scroll-to-component');
  }, []);

  return (
    <BlogLayout>
      <h3 className="font-bold text-[28px] py-3 px-6 lg:py-8 lg:px-0 ">
        {name}
      </h3>
      <div className="bg-white rounded w-full py-4 px-6">
        <AuthorProfile
          imageUrl={imageUrl}
          description={description}
          name={name}
          link={{
            as: `/author/${slug}`,
            href: `/blog/author/${slug}`,
          }}
        />
      </div>
      <div className="flex justify-end py-6 mr-4 lg:mr-0" ref={selectContainer}>
        <div className="flex items-center gap-3">
          <p className="font-bold text-sm">Sort by</p>
          <DropdownSelect
            variant="white"
            items={SELECT_ITEMS}
            defaultSelectedItem={SELECT_ITEMS[0]}
            handleSelectedItemchange={item => {
              item.selectedItem.onClick();
            }}
          />
        </div>
      </div>
      <div className="pb-6">
        <ArticleList
          articles={articles}
          currentPage={currentPage}
          totalPage={authorArticles.articleResponse.data.totalPages}
          onPageChange={onPageChange}
          loading={isLoading}
        />
      </div>
    </BlogLayout>
  );
};

export default AuthorContent;
